var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4V28H28V4H4ZM11.4649 23.9386H7.90414V13.2258H11.4649V23.9386ZM9.68452 11.7637H9.66099C8.46653 11.7637 7.69231 10.9407 7.69231 9.91218C7.69231 8.86103 8.48916 8.06143 9.70783 8.06143C10.9268 8.06143 11.6758 8.86103 11.6991 9.91218C11.6991 10.9407 10.9268 11.7637 9.68452 11.7637ZM24.3077 23.9386H20.746V18.2072C20.746 16.7677 20.2314 15.7851 18.9423 15.7851C17.9578 15.7851 17.3728 16.4467 17.1151 17.0875C17.0214 17.3165 16.9969 17.6347 16.9969 17.9557V23.9386H13.4345C13.4345 23.9386 13.4823 14.2309 13.4345 13.2259H16.9969V14.7439C17.4702 14.0156 18.3149 12.9744 20.2069 12.9744C22.5508 12.9744 24.3077 14.5051 24.3077 17.7954V23.9386Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.55439da465669ef0c43bf294a410ca07.svg";
export { ForwardRef as ReactComponent };